import type { CategoriesMap } from '@repo/db';

/** Sort options exposed in the shop toolbar. `best-match` = curated "Featured". */
export type SortOption = 'best-match' | 'newest' | 'best-sellers' | 'price-low' | 'price-high';

/** Full taxonomy map (subjects/styles/rooms/colors/…) sourced from the DB. */
export type FilterCategories = CategoriesMap;

/** The taxonomy dimensions a shopper can filter/browse by, in display order. */
export const FILTER_KEYS = <const>['subjects', 'styles', 'rooms', 'colors'];
export type FilterKey = (typeof FILTER_KEYS)[number];

export interface ActiveFilters {
  subjects?: string[];
  colors?: string[];
  styles?: string[];
  rooms?: string[];
}

export const getActiveFilterCount = (filters: ActiveFilters): number =>
  Object.values(filters).reduce((total, values) => total + (values?.length ?? 0), 0);
